import { JSX, ReactNode } from 'react';
import clsx from 'clsx';

export enum TextAlign {
  LEFT = 'text-left',
  CENTER = 'text-center',
  RIGHT = 'text-right',
}

export enum TextSize {
  size10 = 'text-[10px]',
  size12 = 'text-[12px]',
  size14 = 'text-[14px]',
  size16 = 'text-[16px]',
  size18 = 'text-[18px]',
  size20 = 'text-[20px]',
  size22 = 'text-[22px]',
  size24 = 'text-[24px]',
  size32 = 'text-[32px]',
}

interface TextProps {
  className?: string;
  title?: string | ReactNode;
  text?: string | ReactNode;
  align?: TextAlign;
  size?: TextSize;
  titleTag?: keyof JSX.IntrinsicElements;
}

const Typography = ({
  className,
  title,
  text,
  align = TextAlign.LEFT,
  size = TextSize.size14,
  titleTag: TitleTag = 'h2',
}: TextProps) => {
  return (
    <div className={clsx(className)}>
      {title && <TitleTag className={clsx(size, align)}>{title}</TitleTag>}
      {text && <p className={clsx(size, align)}>{text}</p>}
    </div>
  );
};

export default Typography;
